import { FormControl, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import { DepositTable } from './DepositTable'

export const ModalPayments = ({useFetchInit}) => {

  const {
    //------------- Generales
    //------------- globalStates
    globalStates,
    //------------- Helpers
    Helpers,
    //------------- Formularios
    Forms,
    //------------- FetchData
    FetchData,

    defaultData,
    
    //------------- Actions
    Actions
} = useFetchInit

const {FormRequestGlobal:{formState, onInputChange}} = Forms

  return (
    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} >
      <Grid item xs={12} sm={12} md={12} lg={12} sx={{mt: 2}}>
        <DepositTable useFetchInit={useFetchInit}/>
      </Grid>
    </Grid>

  )
}
